import { Banknote, CreditCard, Gift, Package, Ticket, Wallet, type LucideIcon } from 'lucide-react';

export const paymentMethodConfig: Record<string, { label: string; icon: LucideIcon }> = {
    CASH: { label: 'Bar', icon: Banknote },
    CARD_TERMINAL_STRIPE: { label: 'Kartenzahlung (Stripe)', icon: CreditCard },
    VOUCHER: { label: 'Gutschein', icon: Ticket },
    BUNDLE_VOUCHER: { label: 'Bundle', icon: Package },
    GIFT_CARD: { label: 'Wertgutschein', icon: Gift },
    GHL_PAYMENT_LINK: { label: 'Zahlungslink', icon: CreditCard },
    GHL_MANUAL_PAYMENT: { label: 'Sonstige', icon: CreditCard },
    KLARNA: { label: 'Klarna', icon: CreditCard },
    STRIPE_CHECKOUT: { label: 'Stripe Zahlungslink', icon: CreditCard },
    BANK_TRANSFER: { label: 'Überweisung', icon: Banknote },
    SUMUP: { label: 'SumUp', icon: CreditCard },
    PAYPAL: { label: 'PayPal', icon: Wallet },
};

export const defaultPaymentMethod = { label: 'Unbekannt', icon: CreditCard };
